import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import style from './faq.module.css'

export const Faq = () => {
  const data = useStaticQuery(graphql`
    query{
      allContentfulFranchisee{
        edges{
          node{
            faqs{
              heading{
                id
                heading
              }
              description{
                description
              }
            }
          }
        }
      }
    }
    `)

  const faqdata = data.allContentfulFranchisee.edges;
  const realData = faqdata.map(value => value);
  const questions = realData[0].node.faqs.map(val => val.heading);
  const description = realData[0].node.faqs.map(val => val.description);
  let zipped = questions.map((x, i) => [x, description[i]]);
  const mappedZip = zipped.map(x => [x[0].heading, x[1].description])
  return (
    <div className={style.mainCon}>
    <div className={style.body}>
      <div >
        <h1 className={style.h1}>FAQ</h1>
        <ul className={style.ul}>
          {mappedZip.map((x, i) =>
            <li className={style.li}>
              <input type="checkbox" defaultChecked className={style.input} />
              <i />
              <h2 className={style.h2}>{x[0]}</h2>
              <p className={style.p}>{x[1]}</p>
            </li>
          )}
        </ul>
      </div>
    </div>
    </div>
  )
}